<template>
    <div class="container-fluid mb-5 ps-5">
        <div class="row">
            <div class="col">
                <img @click="$emit('go-back-event')" src="../../assets/back-button.svg" class="img-fluid cursor-pointer" width="32" alt="">
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row">
            <div class="col text-center">
                <h1 class="thin-text mb-5 fs-3">Quanto mi serve? Il piano</h1>
            </div>
        </div>
    </div>
    <div class="custom-container">
        <form @submit.prevent="validateForm" id="formId" method="post" novalidate="true">
            <div class="row mb-3 d-flex justify-content-center">
                <div class="col-lg-6 text-center">
                    <div class="d-flex flex-row justify-content-center align-items-center">
                        <input v-model="formData.duration" @change="recalculateAmount; checkDuration(formData.duration)" type="number" id="duration" placeholder="Durata del progetto in anni" required>
                        <img class="ms-2 tooltip-icon" src="../../assets/info.svg" alt="" srcset="" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip" data-bs-placement="right" title="Durata minima 10 anni.">
                    </div>
                    <label v-if="formData.duration">Durata del progetto in anni</label>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col text-center">
                    <h5 class="thin-text mb-4">Importo investimento</h5>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-lg-6">
                    <div class="d-flex align-items-center">
                        <input v-model="formData.planType" @change="recalculateAmount"  class="me-2" type="radio" value="annuale" name="amount" id="globale" />
                        <label class="form-check-label me-3">Globale</label>
                        <input v-model="formData.planType" @change="recalculateAmount" class="me-2" type="radio" value="globale" name="amount" id="annuale" />
                        <label class="form-check-label">Annuale</label>
                    </div>
                </div>
                <div class="col-lg-6 text-center">
                    <div class="d-flex flex-row justify-content-center align-items-center">
                        <input type="number" v-model="formData.amountChosen" @change="recalculateAmount" id="importo-scelto" placeholder="Importo scelto" required>
                        <img class="ms-2 tooltip-icon" src="../../assets/info.svg" alt="" srcset="" data-bs-toggle="tooltip" data-bs-custom-class="custom-tooltip" data-bs-placement="right" title="Minimo annuo Euro 3.000 e massimo annuo Euro 20.000.">
                    </div>
                    <label v-if="formData.amountChosen">Importo scelto</label>
                </div>
            </div>
            <div class="row mb-3 d-flex justify-content-center">
                <div class="col-lg-6 text-center">
                    <input type="text" v-model="formData.amountCalculated" id="amount-calculated" :placeholder="'Importo '+(formData.planType ?? '')" disabled required>
                    <label v-if="formData.amountCalculated">Importo {{formData.planType ?? ''}}</label>
                </div>
            </div>
            <div class="row mb-5">
                <div class="col-sm-6 text-center">
                    <select v-model="formData.installmentType" @change="recalculateAmount" id="installmentType" required>
                        <option disabled value="" :selected="true">Modalità rateizzazione</option>
                        <option value="Mensile">Mensile</option>
                        <option value="Trimestrale">Trimestrale</option>
                        <option value="Semestrale">Semestrale</option>
                        <option value="Annuale">Annuale</option>
                    </select>
                    <label v-if="formData.installmentType">Modalità rateizzazione</label>
                </div>
                 <div class="col-sm-6 text-center">
                        <input type="text" v-model="formData.installmentAmount" id="installment-amount" placeholder="Cifra rata" required disabled>
                        <label v-if="formData.installmentAmount">Cifra rata</label>
                </div>
            </div>
            <div class="text-center mb-3">
                <input type="submit" value="Procedi">
            </div>
        </form>
    </div>
    <div class="container" v-if="this.errors.length > 0">
        <div class="row">
            <ul class="list-unstyled col-lg-6 offset-3">
                <li class="alert alert-danger p-2 mb-1" role="alert" :key="key" v-for="(error, key) in this.errors">
                    {{error}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HowMuchScreen',
        emits: ['go-to-event', 'go-back-event', 'save-form-data-event'],
        props: {
            formData: {
                type: Object,
                default(rawProps) {
                    return {
                        duration: null,
                        planType: null,
                        amountChosen: null,
                        amountCalculated: null,
                        installmentType: '',
                        installmentAmount: null
                    }
                }
            }
            
        },
        data() {
            return {
                errors: []
            }
        },
        methods: {
            checkDuration(duration) {
                let today = new Date();
                let dateOfBirth = new Date(this.formData.insuredFigure.dateOfBirth);
                let days = (today.getUTCFullYear() - dateOfBirth.getUTCFullYear()) * 360 + (today.getUTCMonth() - dateOfBirth.getUTCMonth()) * 30 + (today.getUTCDate() - dateOfBirth.getUTCDate());
                let age = Math.round(days/360);
                // Min: 10, Max: 88 - age
                if ( (duration < 10) || (duration > (88 - age)) ) {
                    this.errors = [];
                    this.errors.push("Durata non valida");
                    return false;
                } else {
                    // Remove Error from list
                    const index = this.errors.indexOf("Durata non valida");
                    if (index > -1) { 
                        this.errors.splice(index, 1); 
                    }
                }
                return true;
            },
            validateForm() {
                this.errors = [];
                // Check Duration
                if (!this.checkDuration(this.formData.duration)) { }
                if ( !this.formData.duration || this.formData.duration == "") {
                    this.errors.push("Durata del progetto mancante");
                }
                // Check Forms
                if (!this.formData.planType || this.formData.planType == "") {
                    this.errors.push("Modalità investimento mancante");
                }
                if (!this.formData.amountChosen || this.formData.amountChosen == "") {
                    this.errors.push("Importo scelto mancante");
                }
                if (!this.formData.installmentType || this.formData.installmentType == "") {
                    this.errors.push("Modalità rateizzazione mancante");
                }
                // Save Form
                if (this.errors.length === 0) {
                    if (this.formData.duration && this.formData.planType && this.formData.amountChosen && this.formData.installmentType) {
                        // console.log('Saved Form Data');
                        this.$emit('save-form-data-event', this.formData);
                        this.$emit('go-to-event', 'CoverageScreenId');
                        return true;
                    }
                }
            },
            recalculateAmount() {
                if (this.formData.duration && this.formData.planType && this.formData.amountChosen) {
                    if (this.formData.planType === "globale") {
                        this.formData.amountCalculated = this.formData.amountChosen * this.formData.duration;
                        this.formData.amountAnnual = this.formData.amountChosen;
                    }
                    if (this.formData.planType === "annuale") {
                        this.formData.amountCalculated = this.formData.amountChosen / this.formData.duration;
                        this.formData.amountAnnual = this.formData.amountCalculated;
                    }

                    // Installment Calculation
                    let divisor;
                    switch (this.formData.installmentType) {
                        case 'Annuale':
                            divisor = 1;
                            break;
                        case 'Semestrale':
                            divisor = 2;
                            break;
                        case 'Trimestrale':
                            divisor = 4;
                            break;
                        case 'Mensile':
                            divisor = 12;
                            break;
                    }
                    
                    if (divisor) {
                        this.formData.installmentAmount = this.formData.amountAnnual / divisor;
                    }
                    
                    // Check if annualAmount is valid
                    let errorMsg = "Importo annuo non valido";
                    if (!(this.formData.amountAnnual >= 3000 && this.formData.amountAnnual <= 20000)) {
                        if (!this.errors.includes(errorMsg)) {
                            this.errors.push(errorMsg);
                        }
                    } else {
                        // Remove Error from list
                        const index = this.errors.indexOf(errorMsg);
                        if (index > -1) {
                            this.errors.splice(index, 1);
                        }
                    }
                }
            },
        }
    }
</script>